import routes from '@/constants/routes';

export const NAVIGATION_LIST = [
  {
    label: 'My Abōde Overview',
    redirectTo: routes.myAbodeOverview,
  },
  {
    label: 'Market Data',
    redirectTo: routes.marketData,
  },
  {
    label: 'Sold Data',
    redirectTo: routes.soldData,
  },
  {
    label: 'Comparables',
    redirectTo: routes.comparables,
  },
];

export default {
  NAVIGATION_LIST,
};
